import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { ShieldAlert, ShieldCheck } from 'lucide-react';
import { cn } from '@/lib/utils';

export const RoleBadge = ({ role }) => {
  if (role === 'super_admin') {
    return (
      <Badge className="bg-amber-500/20 text-amber-400 border border-amber-500/30 hover:bg-amber-500/20">
        <ShieldAlert className="w-3 h-3 mr-1" />Super
      </Badge>
    );
  }
  if (role === 'admin') {
    return (
      <Badge className="bg-indigo-500/20 text-indigo-300 border border-indigo-500/30 hover:bg-indigo-500/20">
        <ShieldCheck className="w-3 h-3 mr-1" />Admin
      </Badge>
    );
  }
  return <Badge variant="outline" className="text-muted-foreground">User</Badge>;
};

export const StatCard = ({ icon: Icon, label, value, accent }) => (
  <Card className="bg-zinc-950/60 border-white/5">
    <CardContent className="p-5 flex items-start gap-4">
      <div className={cn('w-10 h-10 rounded-lg flex items-center justify-center', accent)}>
        <Icon className="w-5 h-5" strokeWidth={1.5} />
      </div>
      <div>
        <p className="text-xs uppercase tracking-widest text-muted-foreground">{label}</p>
        <p className="font-heading text-2xl font-semibold mt-1">{value}</p>
      </div>
    </CardContent>
  </Card>
);

export const PLAN_OPTIONS = [
  { id: 'free', label: 'Free' },
  { id: 'starter', label: 'Starter' },
  { id: 'pro', label: 'Pro' },
];

export const ROLE_OPTIONS = [
  { id: 'user', label: 'User' },
  { id: 'admin', label: 'Admin' },
  { id: 'super_admin', label: 'Super Admin' },
];

export const formatRelativeTime = (iso) => {
  const time = new Date(iso);
  const sec = Math.max(0, Math.floor((Date.now() - time.getTime()) / 1000));
  if (sec < 60) return `${sec}s ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  return `${Math.floor(sec / 86400)}d ago`;
};
